//
// KeyManager.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";

var KeyManager = createModule("commons::KeyManager", [], ClosetObject, [
    ,
    ,
    ,
    ,
    ,
    {
        isPressed: [2,4],
        pressKey: [0,4],
        releaseKey: [0,4],
        didHandleLastAction: [2],
        releaseAllKeys: [0],
    },
    ,
]);
export default KeyManager;
